import SwedishSearchFormHandler from './swedish-search-form-handler.mjs';

export default class CommercialSearchFormHandler extends SwedishSearchFormHandler {
  // ...commercial-specific logic or overrides...
}
